import { API_HOST } from "APIRoutes/config";
import axiosModule from "axios";
import { utils } from "./utils";
const axios = axiosModule.create({
  baseURL: API_HOST,
  headers: { "Content-Type": "application/json" },
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const errorResponse = error?.response;
    if (errorResponse?.data?.statusCode) {
      const errorResponseData = errorResponse?.data ?? {};
      if (!utils.isArrayEmpty(errorResponseData?.message)) {
        errorResponseData?.message?.map((message: string) =>
          utils.toastError(message)
        );
      } else {
        utils.toastError(errorResponseData?.message);
      }
    }
    return Promise.reject(
      (errorResponse && errorResponse.data) || "Something went wrong"
    );
  }
);

export default axios;
